import AuthButtonContainer from './AuthButtonContainer';
import { IStoreState } from '../../../modules';
import TrxSignChallengeRequest from '../challenge-request/TrxSignChallengeRequest';
import { connect } from 'react-redux';
import { faSignature } from '@fortawesome/free-solid-svg-icons';

class TrxSignAuthButton extends AuthButtonContainer<Props, {}> {
  static icon = faSignature
  static authname = "Transaction Signing"
  static description = "Sign transaction in mobile app"
  static authLevel = 0

  static challengeRequestComponent = TrxSignChallengeRequest

  get enrolled(): boolean {
    return this.props.authmethods.trxSign.enrolled
  }

  get required(): boolean {
    return this.props.challenge.requiredCredentials.trxSign ? true : false
  }
}

const mapStateToProps = ({ authmethods, challenge }: IStoreState) => ({
  authmethods,
  challenge,
})

interface Props extends ReturnType<typeof mapStateToProps> {
}

export default connect(mapStateToProps)(TrxSignAuthButton)